<template>
  <section class="section">
    <h1 class="title">Products</h1>
    <div class="columns">
      <div class="column is-one-quarter">
        <div class="columns is-mobile is-multiline">
          <b-select
            placeholder="Select product"
            @input="onChangeProduct($event)"
          >
            <option
              v-for="(product, index) in products"
              :key="index"
              :value="product.productName"
            >
              {{ product.productName }}
            </option>
          </b-select>
        </div>

        <div class="column is-one-half">
          <div class="control">
            <b-button @click="addProduct">New Product</b-button>
          </div>
        </div>
      </div>
      <div class="column is-8">
        <section class="section is-main-section">
          <form @submit.prevent="save">
            <div v-if="errors.length" class="column is-one-third">
              <b>Please correct the following error(s):</b>
              <ul>
                <li v-for="(error, index) in errors" :key="index">
                  {{ error }}
                </li>
              </ul>
            </div>
            <div class="columns is-mobile is-multiline">
              <div class="column is-one-third">
                <b-field label="Product" custom-class="labelProduct" horizontal>
                  <b-input
                    v-model="product"
                    id="product"
                    :disabled="isDisabled"
                    required
                    @blur="checkForm"
                  />
                </b-field>
                <b-field
                  label="Default Unit"
                  custom-class="labelProduct"
                  horizontal
                >
                  <b-input
                    v-model="unit"
                    id="unit"
                    required
                    @blur="checkForm"
                  ></b-input>
                </b-field>
                <b-field
                  label="Default Rate"
                  custom-class="labelProduct"
                  horizontal
                >
                  <b-numberinput
                    step="0.1"
                    v-model="rate"
                    id="rate"
                    class="numInput"
                    required
                    @blur="checkForm"
                  ></b-numberinput>
                </b-field>
                <b-checkbox v-model="active" id="active">Active</b-checkbox>
              </div>
            </div>
            <hr />
            <div class="control">
              <b-button
                v-if="isSaveEnabled"
                native-type="submit"
                type="is-primary"
                >Save Product</b-button
              >
            </div>
          </form>
        </section>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  name: "Forms",
  components: {},
  data() {
    return {
      data: [],
      products: [],
      name: "",
      selected: null,
      isSaveEnabled: false,
      isDisabled: true,
      errors: [],
      product: null,
      unit: null,
      rate: null,
      active: false
    };
  },
  computed: {},
  methods: {
    onChangeProduct(product) {
      this.getProduct(product);
      this.isSaveEnabled = true;
    },
    addProduct() {
      this.clearForm();
      this.isDisabled = false;
    },
    clearForm() {
      this.product = "";
      this.unit = "";
      this.rate = 0;
      this.active = false;
    },
    save(e) {
      var errorFound = false;

      this.isLoading = true;

      this.errors = [];

      if (!this.isDisabled) {
        var x = "";
        var current = false;
        for (x in this.products) {
          if (this.product === this.products[x].productName) {
            current = true;
          }
        }

        if (current) {
          this.errors.push("This product already exists.");
          errorFound = true;
        }
      }

      if (this.errors.length > 0) {
        return true;
      }

      e.preventDefault();

      if (!errorFound) {
        if (this.saveProduct()) {
          setTimeout(() => {
            this.isLoading = false;
            this.$buefy.snackbar.open({
              message: "Product information has been saved",
              queue: false
            });
          }, 500);
        }
      }
    },
    checkForm() {
      var missingData = false;
      if (document.getElementById("product").value === "") {
        missingData = true;
      }
      if (document.getElementById("unit").value === "") {
        missingData = true;
      }
      if (document.getElementById("rate").value === "") {
        missingData = true;
      }

      if (!missingData) {
        this.isSaveEnabled = true;
      } else {
        this.isSaveEnabled = false;
      }
    },
    async saveProduct() {
      if (!this.isDisabled) {
        this.postProduct();
        this.products = [];
        this.product = "";
        this.isDisabled = true;
        this.getProducts();
      } else {
        this.putProduct();
      }
    },
    async putProduct() {
      try {
        await axios.put(
          this.$store.state.apiUrl + "lookup/transport_product/" + this.product,
          {
            defaultUnit: this.unit,
            defaultRate: this.rate,
            active: this.active
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async postProduct() {
      try {
        await axios.post(
          this.$store.state.apiUrl + "lookup/transport_product/",
          {
            productName: this.product,
            defaultUnit: this.unit,
            defaultRate: this.rate,
            active: this.active
          },
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
      } catch (error) {
        console.log(error);
      }
    },
    async getProduct(product) {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/transport_product/" + product,
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.product = product;
        this.rate = data[0].defaultRate;
        this.unit = data[0].defaultUnit;
        this.active = data[0].active;
      } catch (error) {
        console.log(error);
      }
    },
    async getProducts() {
      // Use Axios to make a call to the API
      try {
        const { data } = await axios.get(
          this.$store.state.apiUrl + "lookup/transport_product",
          {
            headers: {
              Authorization: "Bearer " + this.$cookies.get("user_token"),
              "Content-Type": "application/json"
            }
          }
        );
        this.products = data;
      } catch (error) {
        console.log(error);
      }
    }
  },
  created() {
    this.getProducts();
  }
};
</script>
